import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import cx from 'classnames';
import { api, staticpageUploadDir } from '../../config';

class CommonModal extends Component {

    static propTypes = {
        children: PropTypes.node.isRequired,
        // Not required: a modal with no explicit status is simply hidden. Marking it required
        // produced a PropTypes warning on ~117/120 pages (every page that mounts a CommonModal
        // without passing modalStatus). Default to false below.
        modalStatus: PropTypes.bool,
        modalType: PropTypes.string,
        title: PropTypes.string,
        onHide: PropTypes.func.isRequired,
    };

    static defaultProps = {
        modalStatus: false,
    };

    render() {
        const { modalStatus, title, onHide, dialogClassName, modalHeader, modalBody, noCloseIcon, titleHidden, isBookingBanner, safetyMeasuresImage, backdrop, keyboard } = this.props;
        return (
            <Modal
                show={modalStatus}
                animation={false}
                onHide={onHide}
                backdrop={backdrop !== undefined ? backdrop : true}
                keyboard={keyboard !== undefined ? keyboard : true}
                dialogClassName={cx(dialogClassName, 'commonModalContainer')}
            >
                <Modal.Header closeButton={!noCloseIcon ? true : false} className={cx(modalHeader, 'commonModalHeader')}>
                    <Modal.Title>
                        <div className={cx("commonModalTitle", { ['commonModalHeaderLogoContainer']: isBookingBanner })}>
                            {isBookingBanner && safetyMeasuresImage ? (
                                <>
                                    <div className={'commonModalHeaderLogo'}>
                                        <img src={api.apiEndpoint + staticpageUploadDir + safetyMeasuresImage} alt="Safety Measure" />
                                    </div>
                                    {title}
                                </>
                            ) : (
                                <span className={cx(titleHidden ? "visibleHidden" : "")}>{title}</span>
                            )}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={cx(modalBody, 'commonModalBody')}>
                    <div>
                        {this.props.children}
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapState = (state, ownProps) => ({
    // An explicit noCloseIcon prop (e.g. the non-dismissible search screen) wins over the
    // redux-derived one used by the other modals.
    noCloseIcon: ownProps.noCloseIcon !== undefined ? ownProps.noCloseIcon : state?.adminModalStatus?.formData?.noCloseIcon
});


const mapDispatch = {
};

export default connect(mapState, mapDispatch)(CommonModal);  